import { z } from "zod";
import { schemes } from "../../schema-validation";

export const snapshotSchema = z.object({
  companyID: schemes.uuid(),
  policyID: schemes.mongoObjectId(),
  employeeID: schemes.mongoObjectId(),
  employeeCheckID: schemes.uuid(),
  reportingPeriodID: schemes.mongoObjectId(),
  balance: z.number(),
  accrued: z.number(),
  type: z.enum(["accrual", "usage"]).optional(),
});

export type Snapshot = z.infer<typeof snapshotSchema>;

export type SnapshotUpdates = {
  insertOne: {
    document: Snapshot;
  };
}[];

const snapshotCheckTotalsWithUsageSchema = z.object({
  accrued: z.number(),
  balance: z.number(),
  usage: z.number().nullable(),
  ytd_accrued: z.number(),
  ytd_usage: z.number(),
  checks: z.array(schemes.uuid()),
});

const snapshotCheckTotalsWithUsageMapSchema = z.record(
  // employeeID
  z.string(),
  z.record(
    // policyID
    z.string(),
    z.object({
      policyName: z.string(),
      total: z.number(),
      // reportingPeriodID
      reportingPeriods: z.record(
        z.string(),
        snapshotCheckTotalsWithUsageSchema
      ),
    })
  )
);

export type SnapshotCheckTotalsWithUsageMap = z.infer<
  typeof snapshotCheckTotalsWithUsageMapSchema
>;

const getAccrualSnapshotOptsSchema = z.object({
  companyID: schemes.uuid(),
  policyIDs: z.array(schemes.mongoObjectId()).optional(),
  employeeCheckIDs: z.array(schemes.uuid()).optional(),
  employeeIDs: z.array(schemes.mongoObjectId()).optional(),
  ytd: z.boolean().default(false).optional(),
  testMode: z.boolean().default(false).optional(),
});

export type GetAccrualSnapshotOpts = z.infer<
  typeof getAccrualSnapshotOptsSchema
>;
